import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Button } from "@mui/material";
import { usePatient } from "../../state/patientContext";
import { ServerErrors, SummaryError } from "fe-common/commonTypes/errors";
//region [[ Styles ]]
const ServerErrorHandlerComponentView = styled("div")(({ theme }) => ({
  border: "2px solid #E6E4FF",
  borderRadius: "5px",
  padding: "17px",
}));
const Actions = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
}));
const Title = styled("div")(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "17px",
  lineHeight: "17px",
  marginBottom: "10px",
}));

const Description = styled("div")(({ theme }) => ({
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: "19px",
  marginBottom: "10px",
}));

const RefreshButton = styled(Button)(({ theme }) => ({
  "&:hover": {
    background: "#5A52C3",
    color: "white",
  },

  textTransform: "capitalize",
  borderRadius: "30px",
  background: "#5A52C3",
  color: "white",
  height: "32px",
  width: "90px",
  fontWeight: 500,
  fontSize: "13px",
}));

//endregion [[ Styles ]]
//region [[ Props ]]
export interface ServerErrorHandlerComponentProps {
  error: SummaryError;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const ServerErrorHandlerComponent = ({
  ...props
}: ServerErrorHandlerComponentProps) => {
  const { undo } = usePatient();
  const { error } = props;

  const onRefresh = () => {
    undo();
  };

  if (error.kahun_error === ServerErrors.PPI_DETECTED) {
    return (
      <ServerErrorHandlerComponentView>
        <Title>Personal information detected!</Title>
        <Description>
          {`Please remove the following values: ${error.fields.map((f) =>
            f.Type.toLowerCase(),
          )}`}
        </Description>
        <Actions>
          <RefreshButton onClick={onRefresh}>Edit Text</RefreshButton>
        </Actions>
      </ServerErrorHandlerComponentView>
    );
  } else {
    return (
      <ServerErrorHandlerComponentView>
        <Title>Server error</Title>
        <Description>Please refresh to try again</Description>
        <Actions>
          <RefreshButton onClick={onRefresh}>Refresh</RefreshButton>
        </Actions>
      </ServerErrorHandlerComponentView>
    );
  }
};
